import React from "react";
import styles from './FormField.module.css';

function FormField({ label, required, type, options, disabled, value, onChange }) {
  return (
    <div className={styles.fieldWrapper}>
      <label className={styles.label}>
        {required && <span className={styles.required}>*</span>}
        {label}
      </label>
      {type === "dropdown" && (
        <div className={`${styles.input} ${disabled ? styles.disabled : ''}`}>
          <select 
            className={styles.select} 
            disabled={disabled} 
            value={value}
            onChange={onChange}
          >
            {options.map((option, index) => (
              <option key={index} value={option.value}>{option.label}</option>
            ))}
          </select>
        </div>
      )}
    </div>
  );
}

export default FormField;
